import { Box, Skeleton, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import type { TimeOffSummaryGridEvent } from 'modules/shift_management/utils/TimeGridTable/transformEvents'
import type { EventCardSpec } from 'modules/shift_management/utils/TimeGridTable/resolveCard'

const TimeOffSummaryCard: EventCardSpec<TimeOffSummaryGridEvent> = {
  getAppearance: () => ({
    background: 'grey000White',
    opacity: '1',
  }),
  render: (event) => {
    const hasContent = event.absencesCount > 0 || event.publishedRestDaysCount > 0

    return (
      <Box
        role="button"
        onClick={() => {
          if (!hasContent || event.loading) return
          event.onClick()
        }}
      >
        {event.loading ? <Skeleton height="s24" /> : null}
        {!event.loading && event.absencesCount > 0 ? (
          <Box
            background="champagne200"
            minHeight="s24"
            maxHeight="s24"
            alignItems="center"
            justifyContent="center"
            borderRadius={{ all: 'abs008' }}
            paddingX="s8"
            paddingY="s4"
            flexNoShrink
          >
            <Text.Normal size="100" weight="bold" color="grey1000" ellipsis>
              {i18n.tp('shift_management.time_off_row.absences', {
                count: event.absencesCount,
              })}
            </Text.Normal>
          </Box>
        ) : null}
        {!event.loading && event.publishedRestDaysCount > 0 ? (
          <Box
            background="fuchsia200"
            minHeight="s24"
            maxHeight="s24"
            alignItems="center"
            justifyContent="center"
            borderRadius={{ all: 'abs008' }}
            paddingX="s8"
            paddingY="s4"
            flexNoShrink
          >
            <Text.Normal size="100" weight="bold" color="grey1000" ellipsis>
              {i18n.tp('shift_management.time_off_row.rest_days', {
                count: event.publishedRestDaysCount,
              })}
            </Text.Normal>
          </Box>
        ) : null}
      </Box>
    )
  },
}

export { TimeOffSummaryCard }
